import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';
import { WeddingCategory } from '../types';

export const useWeddingCategories = () => {
  return useQuery({
    queryKey: ['weddingCategories'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('wedding_categories')
        .select('*')
        .order('name');
      if (error) throw error;
      return (data || []) as WeddingCategory[];
    },
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
